import { useEffect } from "react";

import PropTypes from "prop-types";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";

import { CenteredLoading } from "../../ui";
import { GeneralInformationSection } from "./general-information-section";
import { OutletAvailabilitySection } from "./outlet-availability-section";
import { DEFAULT_VALUES, VALIDATION_SCHEMA } from "./warehouse-form-constants";

export const WarehouseForm = ({
  defaultValues,
  onSubmit,
  renderActionButton,
  isLoading = false,
}) => {
  const methods = useForm({
    defaultValues: DEFAULT_VALUES,
    resolver: yupResolver(VALIDATION_SCHEMA),
  });
  const { reset, handleSubmit, formState } = methods;

  useEffect(() => {
    if (!defaultValues) {
      return;
    }

    reset({ ...DEFAULT_VALUES, ...defaultValues });
  }, [defaultValues, reset]);

  const onFormSubmit = async (formData) =>
    await onSubmit({
      name: formData.name,
      description: formData.description,
      damagedGoodsWarehouse: formData.damagedGoodsWarehouse,
      status: formData.status,
      warehouseAddress: {
        address: formData.address || null,
        city: formData.city || null,
        country: formData.country || null,
        postalCode: formData.postalCode || null,
        province: formData.province || null,
      },
      warehouseUsers: [
        {
          userId: "386492e2-5963-11ef-a591-0242ac110002",
        },
      ],
      warehouseOutlets: formData.warehouseOutlets.map((warehouseOutlet) => ({
        outletId: warehouseOutlet.outletId,
        type: warehouseOutlet.type,
      })),
    });

  return isLoading ? (
    <CenteredLoading sx={{ height: "100vh" }} />
  ) : (
    <FormProvider {...methods}>
      <Stack
        component="form"
        noValidate
        onSubmit={handleSubmit(onFormSubmit)}
        spacing={3}
      >
        <GeneralInformationSection />
        <OutletAvailabilitySection />
        {renderActionButton({ isLoading: formState.isSubmitting })}
      </Stack>
    </FormProvider>
  );
};

WarehouseForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
  renderActionButton: PropTypes.func,
  isLoading: PropTypes.bool,
};
